<template>
    <TheHeader bgClass="header-bg-color" fontClass="fontColor2"/>

    <ThePageSubTitle titleMsg="Council Member" msg="Our Council Members"/>
    <br/>
    <br/>

    <div class="current-member-list-wrap">
        <div v-for="(item, index) in current" :key="index" class="montserrat-500">
            <img :src="item.image" alt="Item Image" class="item-image" />
            <p class="name">{{ item.name }}</p>
            <p class="title montserrat-600">{{ item.title }}</p>
        </div>
    </div>
    <br/>
    <br/>

    <div style="text-align: center;" class="montserrat-600">- - - Advisor - - -</div>
    <br/>
    <div class="committee-member-list-wrap">
        <div v-for="(item, index) in consultant" :key="index" class="montserrat-500 committee-set-width">
            <img :src="item.image" alt="Item Image" class="item-image" />
            <p class="name">{{ item.name }}</p>
        </div>
    </div>


    <br/>
    <br/>
    <div style="text-align: center;" class="montserrat-600">- - - Committee Member - - -</div>
    <br/>
    <div class="committee-member-list-wrap">
        <div v-for="(item, index) in comittee" :key="index" class="montserrat-500 committee-set-width">
            <img :src="item.image" alt="Item Image" class="item-image" />
            <p class="name">{{ item.name }}</p>
        </div>
    </div>

    <br/>
    <br/>

    <div style="text-align: center;" class="montserrat-600">- - - Past Council Members - - -</div>

    <br/>
    
    <div class="past-member-wrapper">
        <div v-for="(item, index) in pastCouncil" :key="index">
          <button @click="showImage(item.image)" class="custom-button">
            {{ item.year }}
          </button>
        </div>
    </div>

    <transition name="fade">
        <div v-if="visible" class="preview-overlay" @click="closePreview">
          <div class="image-container" @click.stop>
            <img 
              :src="selectedImage" 
              class="preview-image" 
              :style="imageStyle"
              @mousedown="startPan"
              @mousemove="pan"
              @mouseup="stopPan"
              @wheel="handleWheel"
              @dblclick="resetZoom"
            />
            <div class="zoom-controls" @click.stop>
              <button @click="zoomIn" class="zoom-btn">+</button>
              <button @click="zoomOut" class="zoom-btn">-</button>
              <button @click="resetZoom" class="zoom-btn" style="font-size: 11px;">Reset</button>
            </div>
          </div>
          <span class="close-btn" @click="closePreview">✖</span>
        </div>
    </transition>

    <br/>
    
    <TheSponsor bgClass="header-bg-color"/>

    <!-- Copyright -->
    <TheCopyRight/>
</template>

<script>
import TheHeader from '@/components/TheHeader.vue'
import TheGalleryLightBox from '@/components/TheGalleryLightBox.vue'
import TheSponsor from '@/components/TheSponsor.vue'
import TheCopyRight from '@/components/TheCopyRight.vue'
import ThePageSubTitle from '@/components/ThePageSubTitle.vue'

export default {
    name: 'Council Members',
    components: {
        TheHeader,
        TheSponsor,
        TheCopyRight,
        TheGalleryLightBox,
        ThePageSubTitle
    },
    data() {
        return {
            current: [
                {
                    image: require('@/assets/images/communities/current/01.jpg'), 
                    name: 'Luei Chee Fong (雷志方)',
                    title: 'President (主席)'
                },
                {
                    image: require('@/assets/images/communities/current/02.jpg'), 
                    name: 'Albert Lai (赖荣耀)',
                    title: 'Deputy President (署理主席)'
                },
                {
                    image: require('@/assets/images/communities/current/03.jpg'), 
                    name: 'Lau Ban Ling (刘万龙)',
                    title: 'Vice President (副主席)'
                },
                {
                    image: require('@/assets/images/communities/current/04.jpg'), 
                    name: 'Ng Soon Lim (黄峋霖)',
                    title: 'Vice President (副主席)'
                },
                {
                    image: require('@/assets/images/communities/current/05.jpg'), 
                    name: 'Khoo Kim Lai (邱金来)',
                    title: 'Vice President (副主席)'
                },
                {
                    image: require('@/assets/images/communities/current/06.jpg'), 
                    name: 'Kelvin Chew (周凯文)',
                    title: 'Vice President (副主席)'
                },
                {
                    image: require('@/assets/images/communities/current/07.jpg'), 
                    name: 'Goh Lian Chin (吴年靖)',
                    title: 'Secretary General (秘书长)'
                },
                {
                    image: require('@/assets/images/communities/current/08.jpg'), 
                    name: 'KChong Kai Cheng (张凯程)',
                    title: 'Deputy Secretary General (副秘书长)'
                },
                {
                    image: require('@/assets/images/communities/current/09.jpg'), 
                    name: 'Tan Ten Ken (陈定坚)',
                    title: 'Treasurer (财政)'
                },
                {
                    image: require('@/assets/images/communities/current/10.jpg'), 
                    name: 'Sew Choong Sin (萧松新)',
                    title: 'Deputy Treasurer (副财政)'
                },
            ],
            consultant: [
                {
                    image: require('@/assets/images/communities/advisor/01.jpg'), 
                    name: 'Chung Kwai Fatt (郑桂发)',
                },
                {
                    image: require('@/assets/images/communities/advisor/02.jpg'), 
                    name: 'Liam Kei Wai (甯奇炜)',
                },
                {
                    image: require('@/assets/images/communities/advisor/03.jpg'), 
                    name: 'Ong Chin Chai (王振材)',
                }
            ],
            comittee: [
                {
                    image: require('@/assets/images/communities/current/11.jpg'), 
                    name: 'Foo Siang Kwok (符详广)',
                },
                {
                    image: require('@/assets/images/communities/current/12.jpg'), 
                    name: 'Daniel Goh Su Fan(吴树凡)',
                },
                {
                    image: require('@/assets/images/communities/current/13.jpg'), 
                    name: 'Gan Pin Hao (颜秉豪)',
                },
                {
                    image: require('@/assets/images/communities/current/14.jpg'), 
                    name: 'Bryan Chan (陈育富)',
                },
                {
                    image: require('@/assets/images/communities/current/15.jpg'), 
                    name: 'Heng Kong You (黄公佑)',
                },
                {
                    image: require('@/assets/images/communities/current/16.jpg'), 
                    name: 'Chong Kim Keong (锺金强)',
                },
                {
                    image: require('@/assets/images/communities/current/17.jpg'), 
                    name: 'Ronald Tan (陈晓翔)',
                },
                {
                    image: require('@/assets/images/communities/current/18.jpg'), 
                    name: 'Seah Wei Kin (谢东朔)',
                },
                {
                    image: require('@/assets/images/communities/current/19.jpg'), 
                    name: 'Seow Kim Soon (萧锦顺)',
                },
                {
                    image: require('@/assets/images/communities/current/20.jpg'), 
                    name: 'Jay Ong Kong Jie (王广杰)',
                },
                {
                    image: require('@/assets/images/communities/current/21.jpg'), 
                    name: 'Teh Han Jien (郑汉建)',
                },
                {
                    image: require('@/assets/images/communities/current/22.jpg'), 
                    name: 'Peter Sim (JMCOA) (沈雄伟)',
                },
                {
                    image: require('@/assets/images/communities/current/23.jpg'), 
                    name: 'Tan Wey Zen (MCANM) (陈玮朕)',
                },
                {
                    image: require('@/assets/images/communities/current/24.jpg'), 
                    name: 'Robert Chiew (Sarawak Rep.) (周顺寿)',
                },
            ],
            pastCouncil: [
                {
                    year: '2023 - 2025',
                    image: require('@/assets/images/communities/past-member/council_2023-2025.jpg')
                },
                {
                    year: '2021 - 2023',
                    image: require('@/assets/images/communities/past-member/council_2021-2023.jpg')
                },
                {
                    year: '2019 - 2021',
                    image: require('@/assets/images/communities/past-member/council_2019-2021.jpg')
                },
                {
                    year: '2017 - 2018',
                    image: require('@/assets/images/communities/past-member/council_2018-2019.jpg') // or public path like '/images/image-2017-2018.png'
                },
                {
                    year: '2015 - 2016',
                    image: require('@/assets/images/communities/past-member/council_2015-2017.jpg')
                },
                {
                    year: '2013 - 2014',
                    image: require('@/assets/images/communities/past-member/council_2013-2014.jpg') 
                },
                {
                    year: '2011 - 2012',
                    image: require('@/assets/images/communities/past-member/council_2011-2012.jpg')
                },
                {
                    year: '2009 -2010',
                    image: require('@/assets/images/communities/past-member/council_2009-2010.jpg')
                },
                {
                    year: '2007 - 2008',
                    image: require('@/assets/images/communities/past-member/council_2007-2008.jpg')
                },
                {
                    year: '2005 - 2006',
                    image: require('@/assets/images/communities/past-member/council_2005-2006.jpg')
                },
                {
                    year: '2003 - 2004',
                    image: require('@/assets/images/communities/past-member/council_2003-2004.jpg')
                },
                {
                    year: '2001 - 2002',
                    image: require('@/assets/images/communities/past-member/council_2001-2002.jpg')
                },
                {
                    year: '1999 - 2000',
                    image: require('@/assets/images/communities/past-member/council_1999-2000.jpg')
                },
                {
                    year: '1997 - 1998',
                    image: require('@/assets/images/communities/past-member/council_1997-1998.jpg')
                },
                {
                    year: '1995 - 1996',
                    image: require('@/assets/images/communities/past-member/council_1995-1996.jpg')
                },
                {
                    year: '1993 - 1994',
                    image: require('@/assets/images/communities/past-member/council_1993-1994.jpg')
                },
                {
                    year: '1991 - 1992',
                    image: require('@/assets/images/communities/past-member/council_1991-1992.jpg')
                },
                {
                    year: '1989 - 1991',
                    image: require('@/assets/images/communities/past-member/council_1989-1991.jpg')
                },
                {
                    year: '1987 - 1989',
                    image: require('@/assets/images/communities/past-member/council_1987-1989.jpg')
                },
            ],
            visible: false,
            selectedImage: '',
            currentScale: 1,
            translateX: 0,
            translateY: 0,
            isPanning: false,
            startX: 0,
            startY: 0,
        };
    },
    methods: {
        showImage(image) {
            this.selectedImage = image;
            this.visible = true;
            this.currentScale = 1;
            this.translateX = 0;
            this.translateY = 0;
            this.isPanning = false;
            this.startX = 0;
            this.startY = 0;
        },
        closePreview() {
            this.visible = false;
            this.selectedImage = '';
            this.currentScale = 1;
            this.translateX = 0;
            this.translateY = 0;
            this.isPanning = false;
            this.startX = 0;
            this.startY = 0;
        },
        startPan(event) {
            if (event.button === 0) { // Left mouse button
                this.isPanning = true;
                this.startX = event.clientX - this.translateX;
                this.startY = event.clientY - this.translateY;
            }
        },
        pan(event) {
            if (this.isPanning) {
                this.translateX = event.clientX - this.startX;
                this.translateY = event.clientY - this.startY;
            }
        },
        stopPan() {
            this.isPanning = false;
        },
        handleWheel(event) {
            event.preventDefault();
            const delta = event.deltaY;
            const zoomFactor = delta > 0 ? 0.9 : 1.1;
            const newScale = Math.max(0.1, Math.min(5, this.currentScale * zoomFactor));
            this.currentScale = newScale;
        },
        zoomIn() {
            const newScale = Math.min(5, this.currentScale * 1.2);
            this.currentScale = newScale;
        },
        zoomOut() {
            const newScale = Math.max(0.1, this.currentScale * 0.8);
            this.currentScale = newScale;
        },
        resetZoom() {
            this.currentScale = 1;
            this.translateX = 0;
            this.translateY = 0;
        }
    },
    computed: {
        imageStyle() {
            return {
                transform: `translate(${this.translateX}px, ${this.translateY}px) scale(${this.currentScale})`
            };
        }
    }
}

</script>

<style scoped>
.current-member-list-wrap, .committee-member-list-wrap{
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    margin: 0 auto;
    gap: 20px;
    justify-content: center;
    text-align: center;
}


.current-member-list-wrap img {width: 150px;}
.committee-member-list-wrap img {width: 150px;}
.name { margin: 5px 0; font-size: 12px;}
.title {font-size: 14px; width: 150px;}
.committee-set-width {max-width: 150px;}

p {margin: 0;}

.past-member-wrapper {display: flex; flex-wrap: wrap; width: 100%; justify-content: center; gap: 10px;}

@media screen and (min-width: 640px) {
    .current-member-list-wrap, .committee-member-list-wrap {
        gap: 40px;
        text-align: center;
        width: 75%;
    }
    .current-member-list-wrap img {width: 250px;}
    .name {font-size: 14px;}
    .title {font-size: 16px; width: auto;}
    .past-member-wrapper {width: 60%; margin: 0 auto; gap: 20px;}
    .committee-member-list-wrap .name {font-size: 12px;}
    .committee-set-width {max-width: unset;}
}

.custom-button {
  padding: 8px 16px;
  background-color: #fff200;
  color: #666666;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  width: 110px;
}

.custom-button:hover {
    background-color: #e8e6ba;
    transition: background-color 0.3s ease, color 0.3s ease;
}

.preview-overlay {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.image-container {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 90%;
  height: 90%;
  overflow: hidden;
}

.preview-image {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  box-shadow: 0 0 20px rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  transition: transform 0.1s ease;
  cursor: grab;
}

.preview-image:active {
  cursor: grabbing;
}

.zoom-controls {
  position: absolute;
  top: 20px;
  right: 20px;
  display: flex;
  gap: 8px;
  padding: 8px;
  border-radius: 8px;
  z-index: 10;
  backdrop-filter: blur(5px);
}

.zoom-btn {
  background-color: #fff;
  color: #333;
  border: none;
  width: 35px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  transition: all 0.2s ease;
}

.zoom-btn:hover {
  background-color: #f0f0f0;
  transform: scale(1.1);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
}

.zoom-btn:active {
  transform: scale(0.95);
}

.close-btn {
  position: absolute;
  top: 30px;
  right: 30px;
  font-size: 28px;
  color: white;
  cursor: pointer;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.4s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

</style>